import React, { useState, useEffect } from "react";
import cityTimezones from "city-timezones";

const LocalTime = ({ city, state, country }) => {
  const [localTime, setLocalTime] = useState("");

  const getTimezone = () => {
    let timezone = "";
    if (city) {
      const cityLookup = cityTimezones.lookupViaCity(city);
      if (cityLookup && cityLookup.length > 0) {
        // If there are multiple, maybe filter by country/state, but taking the first usually works if it's famous
        // Let's try to match country if possible, or just take the first one
        let matched = cityLookup[0];
        if (country) {
          const matchByCountry = cityLookup.find(c =>
            c.country && country.toLowerCase().includes(c.country.toLowerCase())
          );
          if (matchByCountry) {
            matched = matchByCountry;
          }
        }
        timezone = matched.timezone;
      }
    }
    return timezone;
  };

  useEffect(() => {
    const timezone = getTimezone();
    if (!timezone) {
      setLocalTime("--");
      return;
    }

    const updateTimer = () => {
      try {
        const timeString = new Intl.DateTimeFormat('en-US', {
          timeZone: timezone,
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: true
        }).format(new Date());

        setLocalTime(timeString);
      } catch (e) {
        setLocalTime("--");
      }
    };

    updateTimer();
    const intervalId = setInterval(updateTimer, 1000);

    return () => clearInterval(intervalId);
  }, [city, state, country]);

  if (!localTime || localTime === "--") return null;

  return (
    <div className="localTime contactDate">
      <p>Local time</p>
      <h6>{localTime}</h6>
    </div>
  );
};

export default LocalTime;
